import { Component, Input } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { UsuarioProvider } from 'src/app/providers/usuario.provider';

@Component({
    selector: 'app-trocar-localidade',
    templateUrl: './trocar-localidade.component.html',
    styleUrls: ['./trocar-localidade.component.scss'],
})
export class TrocarLocalidadeComponent {

    @Input() localidadeSelecionada: any;
    @Input() localidades: Array<any>;
    @Input() isUfMunicipio: boolean;
    @Input() isEstadual: boolean;

    constructor(
        private popoverCtrl: PopoverController,
        public usuarioProvider: UsuarioProvider
    ) { }

    trocarLocalidade(localidade: any) {
        this.popoverCtrl.dismiss(localidade);
    }

    close() {
        this.popoverCtrl.dismiss();
    }
}
